import AuthService from '../../AuthService';
const Contact = {
  getContact(page){
    return AuthService.get(`/about/contact?page=${page}`);
  },
  showContact(id){
    return AuthService.get(`/about/contact/${id}`);
  },
  createContact(data){
    return AuthService.post(`/about/contact`,data);
  },
  updateContact(id,data){
    return AuthService.put(`/about/contact/${id}`,data);
  },
  deleteContact(id){
    return AuthService.delete(`/about/contact/${id}`);
  },
}
export default Contact
